import { useQuery } from '@tanstack/react-query'
import { useApiClientUser } from '~/@api/client/useApiClientUser'

function usePhonePrefixes() {
  const client = useApiClientUser()

  return useQuery({
    queryKey: ['phone-prefixes'],
    queryFn: () =>
      client.user
        .settingsControllerGetPhonePrefixes({ secure: true })
        .then(({ data }) => data.items),
  })
}

export { usePhonePrefixes }
